// Admins can view the app as another user. The target's id lives in sessionStorage, so it lasts for
// this tab, survives a reload and ends when the tab closes. Every API call sends it in a header and
// the server runs the request as that user. Starting and stopping reload the page, because
// everything already loaded belongs to the other person.
const STORAGE_KEY = 'ppc:impersonate-user-id';

export const IMPERSONATION_HEADER = 'X-Impersonate-User-Id';

export const getImpersonatedUserId = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
};

export const startImpersonating = (userId) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(userId));
  } catch {
    return;
  }
  // Start from Projects: the page the admin is on may be one the target can't open.
  window.location.assign('/');
};

export const stopImpersonating = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // nothing stored, nothing to stop
  }
  window.location.reload();
};

// Any impersonation_* refusal means: drop it and reload as yourself, so a refused
// impersonation can never lock the admin out.
export const isImpersonationRefusal = async (response) => {
  if (response.ok || response.status < 400 || response.status >= 500) return false;
  try {
    const body = await response.clone().json();
    return typeof body?.error === 'string' && body.error.startsWith('impersonation_');
  } catch {
    return false;
  }
};
